module.exports = __webpack_public_path__ + "static/media/s_v10_5.406434f3.mp3";